export class ProgressBarModel {
  max: number;
  value: number;

  constructor(max: number, value: number) {
    this.max = max;
    this.value = value;
  }
}
